var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnquiryRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_566",
    "data-name": "Group 566",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12713",
    "data-name": "Path 12713",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12714",
    "data-name": "Path 12714",
    d: "M7.664,25.149a1.3,1.3,0,0,1-.5-.1,1.287,1.287,0,0,1-.791-1.189v-2a.79.79,0,0,0-.79-.79,2.334,2.334,0,0,1-2.332-2.332V7.545A2.334,2.334,0,0,1,5.585,5.213H23.113a2.334,2.334,0,0,1,2.332,2.332V18.738a2.334,2.334,0,0,1-2.332,2.332H12.666a.79.79,0,0,0-.554.226L8.567,24.779a1.288,1.288,0,0,1-.9.37M5.585,6.755a.79.79,0,0,0-.79.79V18.738a.79.79,0,0,0,.79.79,2.335,2.335,0,0,1,2.332,2.332v1.4l3.115-3.06a2.318,2.318,0,0,1,1.634-.668H23.113a.79.79,0,0,0,.79-.79V7.545a.79.79,0,0,0-.79-.79Z",
    transform: "translate(0.651 1.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12715",
    "data-name": "Path 12715",
    d: "M12.673,17.648H8.012a1.233,1.233,0,0,1-.936-.431,1.209,1.209,0,0,1-.281-.971,4.418,4.418,0,0,1,2.228-3.388.161.161,0,0,0,.079-.144v-.1a.163.163,0,0,0-.079-.145A4.418,4.418,0,0,1,6.8,9.08a1.209,1.209,0,0,1,.281-.971,1.232,1.232,0,0,1,.936-.43h4.661a1.232,1.232,0,0,1,.936.43,1.209,1.209,0,0,1,.281.971,4.418,4.418,0,0,1-2.228,3.388.163.163,0,0,0-.079.145v.1a.161.161,0,0,0,.079.144,4.418,4.418,0,0,1,2.228,3.388,1.209,1.209,0,0,1-.281.971,1.233,1.233,0,0,1-.936.431M8.012,8.738a.176.176,0,0,0-.133.061.149.149,0,0,0-.037.122,3.417,3.417,0,0,0,1.65,2.6,1.223,1.223,0,0,1,.67,1.094v.1a1.225,1.225,0,0,1-.67,1.094,3.414,3.414,0,0,0-1.65,2.6.148.148,0,0,0,.037.121.176.176,0,0,0,.133.061h4.661a.179.179,0,0,0,.133-.061.144.144,0,0,0,.036-.121,3.413,3.413,0,0,0-1.649-2.6,1.225,1.225,0,0,1-.67-1.094v-.1a1.223,1.223,0,0,1,.67-1.094,3.416,3.416,0,0,0,1.649-2.6.145.145,0,0,0-.036-.122.179.179,0,0,0-.133-.061Z",
    transform: "translate(1.356 1.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12716",
    "data-name": "Path 12716",
    d: "M19.3,8.473a2.725,2.725,0,0,1,.854,2.106.125.125,0,0,0,0,.03,2.533,2.533,0,0,1-.869,2.075l-.041.032a3.68,3.68,0,0,1-1.939.69.444.444,0,0,0-.418.419l-.014.259a.443.443,0,0,1-.443.42h-.522a.443.443,0,0,1-.443-.43l-.041-1.289a.443.443,0,0,1,.443-.458,4.668,4.668,0,0,0,2.023-.347l.062-.03a1.39,1.39,0,0,0,.683-1.356,1.541,1.541,0,0,0-.4-1.128.5.5,0,0,0-.044-.043,1.6,1.6,0,0,0-1.148-.4,1.665,1.665,0,0,0-1.156.383c-.014.013-.03.026-.043.041a1.453,1.453,0,0,0-.385.742.444.444,0,0,1-.436.36h-.594a.441.441,0,0,1-.439-.5,2.923,2.923,0,0,1,.338-.976A2.557,2.557,0,0,1,15.4,8.062,3.494,3.494,0,0,1,17.032,7.7a3.234,3.234,0,0,1,2.268.773m-3.874,8.8a1.012,1.012,0,0,1,.721-1.733.961.961,0,0,1,.707.292,1.036,1.036,0,0,1,0,1.441.961.961,0,0,1-.707.292.98.98,0,0,1-.724-.292Z",
    transform: "translate(2.797 1.539)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnquiryRate);
export default __webpack_public_path__ + "static/media/icon-enquiry_rate.bd4058b88ff7cc5e1df0c713d0eb3950.svg";
export { ForwardRef as ReactComponent };